import React from 'react';
import { Spinner, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Http from '../Http'
import axios from 'axios'
import { DefaultDateTimeFormatOptions } from '../components/Utils'

class Documents extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      documents: [],
      loading: true,
    }
    this.api = '/api/v1';
  }

  componentDidMount() {
    Http.get(`${this.api}/companies/documents`)
      .then((response) => {
        const { data } = response.data;
        if (data == []) {
          // alert('Si è verificato un errore: competitor non valido')
          this.setState({
            error: 'Si è verificato un errore',
            loading: false
          });
        }
        this.setState({
          documents: data,
          loading: false
        });
      })
  }

  downloadFile(id, originalName) {
    axios({
      url: `${this.api}/download-document/${id}`,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${originalName}`);
      document.body.appendChild(link);
      link.click();
    });
  }

  deleteFile(id) {
    axios({
      url: `${this.api}/delete-document/${id}`,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      this.componentDidMount()
    });
  }

  render() {
    let { roles } = this.props.user
    let { documents, loading } = this.state
    if (loading) {
      return (
        <div className="content text-center">
          <Spinner style={{ width: '3rem', height: '3rem' }} type="grow" />
        </div>
      )
    } else {
      return (<div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="row">
                <div className="col">
                  <h3 className="text-left m-3">DOCUMENTI</h3>
                </div>
              </div>
              <div className="card-body">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Documento</th>
                      <th className="text-right">Data di presentazione</th>
                      <th className="text-center">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.map(d => {
                      return (<tr key={d.id}>
                        <td>{d.name}</td>
                        <td className="text-right">{new Intl.DateTimeFormat('it-IT', DefaultDateTimeFormatOptions()).format(new Date(d.created_at))}</td>
                        <td className="text-center">
                          <Button className="animation-on-hover text-center ml-3 btn btn-primary btn-sm" onClick={() => this.downloadFile(d.id, d.original_name)}>Download</Button>
                          {roles.indexOf("superadmin") > -1 && (<Button className="animation-on-hover text-center ml-3 btn btn-danger btn-sm" onClick={() => this.deleteFile(d.id)}>Elimina</Button>)}</td>
                      </tr>)
                    })}

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


      </div>)
    }
  }
}

Documents.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Documents);